import React, { useEffect, useRef, useState } from 'react'
import { Rimg } from 'components/images'

export default function VideoWithCoverHoverPlay({
	cover,
	coverPosition,
	coverMobilePosition,
	videoUrl,
}) {
	let deviceType = null
	if (typeof window === 'object') {
		deviceType = window.innerWidth < 1024 ? 'mobile' : 'desktop'
	}
	const videoRef = useRef()
	const [isLoaded, setIsLoaded] = useState(false)

	console.log(deviceType, isLoaded, cover)

	const containerProps =
		deviceType === 'mobile'
			? {}
			: {
					onMouseEnter: () => videoRef.current.play(), //setIsHovered(true),
					onMouseLeave: () => videoRef.current.pause(), //setIsHovered(false),
			  }

	useEffect(() => {
		// const isSafari = !!navigator.userAgent.match(/Version\/[.\d]+.*Safari/)
		const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
		if (!iOS) return

		videoRef.current.addEventListener('suspend', () => {
			document.body.addEventListener('touchstart', forceAutoPlay)

			function forceAutoPlay(e) {
				videoRef.current.play()

				if (!videoRef.current.paused) {
					removeListeners()
				}
			}
			function removeListeners() {
				document.body.removeEventListener('touchstart', forceAutoPlay)
			}
		})
	})

	return (
		<div className="relative h-full w-full" {...containerProps}>
			<video
				className={
					'absolute h-full w-full object-cover' // + (isLoaded ? '' : ' invisible')
				}
				autoPlay={deviceType === 'mobile'}
				loop
				muted
				playsInline
				preload="metadata"
				ref={videoRef}
				src={videoUrl}
				// onPlay={() => setIsPlaying(true)}
				onCanPlayThrough={() => setIsLoaded(true)}
			/>
			{cover && !isLoaded && (
				<Rimg
					className={
						'absolute h-full w-full object-cover' +
						(isLoaded ? ' invisible' : '')
					}
					image={cover}
					position={coverPosition}
					mobilePosition={coverMobilePosition}
					alt="Seeing is experiencing"
				/>
			)}
		</div>
	)
}
